import { useDatabase } from "@nozbe/watermelondb/hooks";
import { useGlobalSettingsProvider } from "../../../../utilities/global-settings/hooks";
import React from "react";
import PaymentMethod from "../../../../utilities/data/model/PaymentMethod";
import { useFocusEffect } from "@react-navigation/native";
import { Q } from "@nozbe/watermelondb";
import { useFormContext } from "react-hook-form";
import { TerminalFormValues } from "../../components/TerminalForm";
import { SelectablePaymentMethodButton } from "../../../point-of-sale/screens/SelectPaymentMethodScreen/components/SelectablePaymentMethodButton";
import {
  Divider,
  Page,
  PayTypeToIcon,
  Button,
} from "@towersystems/roam-common-native";
import { Feather } from "@expo/vector-icons";
import { Colors } from "react-native-ui-lib";
import { useTranslation } from "react-i18next";
import { TerminalFormParamList } from "../../../../types";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { FlatList } from "react-native";

export type SelectPaymentMethodIdsScreenProps = NativeStackScreenProps<
  TerminalFormParamList,
  "SelectPaymentMethodIdsScreen"
>;

export const SelectPaymentMethodIdsScreen = ({
  navigation,
}: SelectPaymentMethodIdsScreenProps) => {
  const [paymentMethods, setPaymentMethods] = React.useState<PaymentMethod[]>(
    []
  );
  const { t } = useTranslation("settings");

  const globalSettings = useGlobalSettingsProvider();

  const database = useDatabase();

  const { control, setValue, formState, handleSubmit, watch } =
    useFormContext<TerminalFormValues>();

  const paymentMethodIds = watch("paymentMethodIds");

  useFocusEffect(
    React.useCallback(() => {
      database
        .get<PaymentMethod>("payment_methods")
        .query(
          Q.where("enabled", true),
          Q.on("pay_types", "internal", Q.eq(false)),
          Q.on("pay_types", "available", Q.eq(true)),
          Q.where("deleted_at", Q.eq(null))
        )
        .fetch()
        .then(setPaymentMethods)
        .catch((e) => console.log(e));
    }, [])
  );
  const handleOnPress = async (id: string) => {
    // if already selected, remove it
    if (paymentMethodIds.includes(id)) {
      setValue(
        "paymentMethodIds",
        paymentMethodIds.filter((pmId) => pmId !== id),
        {
          shouldDirty: true,
          shouldValidate: true,
        }
      );
    }
    // if not selected, add it
    else {
      setValue("paymentMethodIds", [...paymentMethodIds, id], {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
  };
  const renderItem = ({ item }: { item: PaymentMethod }) => {
    const selected =
      paymentMethodIds.includes(item.id) ||
      globalSettings.cashManagedPaymentMethodId === item.id;
    return (
      <SelectablePaymentMethodButton
        disabled={globalSettings.cashManagedPaymentMethodId === item.id}
        onPress={() => handleOnPress(item.id)}
        label={item.name}
        selected={selected}
        icon={<PayTypeToIcon payType={item.payType.id} />}
        componentRight={() => {
          return selected ? (
            <Feather name="check" size={24} color={Colors.primary} />
          ) : null;
        }}
      />
    );
  };

  const footerMarkup = (
    <Button
      label={"Done"}
      backgroundColor={Colors.action}
      color="white"
      onPress={() => navigation.goBack()}
    ></Button>
  );

  return (
    <Page
      title={t("select_terminal_payment_methods_title")}
      secondaryTitle={t("select_terminal_payment_methods_description")}
      footer={footerMarkup}
    >
      <FlatList
        ItemSeparatorComponent={Divider}
        renderItem={renderItem}
        data={paymentMethods}
        scrollEnabled={true}
      ></FlatList>
    </Page>
  );
};
